import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { AppStrategy, CommonStrategy } from './StrategyModals';
import { getTranslationKey } from '../../modules/utils/helpers';

interface StrategyData {
  _id: string;
  name: string;
  [key: string]: any;
}

interface ComponentData {
  currentStrategy: StrategyData;
  userStrategySteps?: string[];
  doStrategyStep: (data: any) => void;
}

function getStrategyComponent(componentData: ComponentData) {
  switch (componentData.currentStrategy.name) {
    case 'apps':
      return <AppStrategy {...componentData} />;
    default:
      return <CommonStrategy {...componentData} />;
  }
}

interface StrategyModalProps {
  currentStrategy?: StrategyData;
  isModalOpen: boolean;
  userStrategySteps?: string[];
  setStrategyModalVisibility: (isOpen: boolean) => void;
  doStrategyStep: (data: any) => void;
}

const StrategyModal: React.FC<StrategyModalProps> = ({
  currentStrategy,
  isModalOpen,
  setStrategyModalVisibility,
  userStrategySteps,
  doStrategyStep
}) =>
  currentStrategy ? (
    <Modal
      centered
      isOpen={isModalOpen}
      toggle={() => setStrategyModalVisibility(!isModalOpen)}
      wrapClassName="modal-primary"
      size="lg"
    >
      <ModalHeader toggle={() => setStrategyModalVisibility(!isModalOpen)}>
        {currentStrategy && getTranslationKey(`strategies.${currentStrategy.name}.title`)}
      </ModalHeader>
      <ModalBody className="strategy-modal-body">
        {getStrategyComponent({
          currentStrategy,
          userStrategySteps,
          doStrategyStep
        })}
      </ModalBody>
      <ModalFooter className="text-center">
        <Button onClick={() => setStrategyModalVisibility(!isModalOpen)} color="primary">
          {getTranslationKey('strategies.close')}
        </Button>
      </ModalFooter>
    </Modal>
  ) : null;

function mapStateToProps({ strategies: { current, isModalOpen }, auth: { strategySteps } }: any) {
  return {
    currentStrategy: current,
    isModalOpen,
    userStrategySteps: strategySteps
  };
}

export default connect(mapStateToProps, actions)(StrategyModal);
